import { useCustomGoogleAnalytics } from '@/hooks/useCustomGoogleAnalytics';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { useEnvConfigModelStore } from '@/models/env-config/envConfig';
import { setAppName, setAppNameLower, setAppRegion } from '@tarslib/utils/lib/utils/appRegion';
import React from 'react';
import { useInitAndListenTheme } from './hooks/useInitAndListenTheme';

export type GlobalComponentProps = {
  children: React.ReactNode;
};

export function GlobalComponent(props: GlobalComponentProps) {
  const { children } = props;
  const googleAnalytics = useDocsDataModelStore((x) => x.docsBaseConfig.googleAnalytics);
  const APP_NAME = useEnvConfigModelStore((x) => x.APP_NAME);
  const APP_NAME_LOWER = useEnvConfigModelStore((x) => x.APP_NAME_LOWER);
  const APP_REGION = useEnvConfigModelStore((x) => x.APP_REGION);

  useInitAndListenTheme();

  useCustomGoogleAnalytics(googleAnalytics);

  React.useMemo(() => {
    setAppRegion(APP_REGION);
    setAppName(APP_NAME);
    setAppNameLower(APP_NAME_LOWER);
  }, [APP_REGION, APP_NAME, APP_NAME_LOWER]);

  return children;
}
